import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import DownloadReport, { ReportRecord } from "./DownloadReport";

const ListReport: React.FC = () => {
  const [reports, setReports] = useState<ReportRecord[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await API.get("TrustAPI", "cost/reports", {});
        if (response.statusCode === 200) {
          // Add an id if the API doesn't provide one, using the index
          const reports = response.body.reports.map((report: any) => ({
            ...report,
          }));
          // Sort reports by generation_date descending (most recent first)
          reports.sort(
            (a: ReportRecord, b: ReportRecord) =>
              new Date(b.generation_date).getTime() -
              new Date(a.generation_date).getTime(),
          );
          setReports(reports);
        }
      } catch (error) {
        console.error("Error fetching reports:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  return (
    <div>
      {/* Fixed static content */}
      <p>
        This page provides an easy way for anyone to download the{" "}
        <strong>Cloud Cost Showback</strong> reports.
      </p>

      <p>
        The Cloud Cost Showback report is a detailed spreadsheet that breaks
        down the costs associated with our Cloud systems, to assist teams in
        optimizing their usage. It includes:
      </p>
      <ul>
        <li>
          <strong>AWS accounts</strong> in TLZ Global, Europe and China
        </li>
        <li>
          <strong>EKS EC2</strong>, <strong>EKS Fargate</strong> and <strong>EKS EFS</strong> resources
        </li>
        <li>
          <strong>Datadog</strong>
        </li>
        <li>
          <strong>MongoDB</strong>
        </li>
      </ul>

      <p>Here are a few important points to note about these reports:</p>
      <ul>
        <li>
          The AWS accounts and EKS services usage is displayed as raw usage
          (excluding discounts/credits/marketplace, see{" "}
          <a
            href="https://docs.devx.resmed.com/docs/products/cloud-governance/optimization/cost/aws/aws-cost-definition"
            target="_blank"
            rel="noreferrer"
          >
            this link
          </a>
          ).
        </li>
      </ul>

      <p>
        For additional details or questions, please contact the DevX Cloud
        Governance team via:{" "}
        <a
          href="https://resmed.slack.com/archives/C03JLS2E7JB"
          target="_blank"
          rel="noreferrer"
        >
          Slack (@devx-ccoe),&nbsp;
        </a>{" "}
        <a
          href="https://teams.microsoft.com/l/channel/19%253AMvQYKRXe1iV-DJncXD67NHdHzfqgGXr26Cz_7fHjVeM1%2540thread.tacv2/General%3FgroupId=8f12e518-a6b6-4db3-a4a5-28ad4ae4da8d%26tenantId=06cf4af3-d7f7-4297-a868-5c36e5cfcb00"
          target="_blank"
          rel="noreferrer"
        >
          MS Teams
        </a>
        ,&nbsp;
        <a
          href="https://docs.devx.resmed.com/docs/support/office-hours"
          target="_blank"
          rel="noreferrer"
        >
          DevX office hours
        </a>
        ,&nbsp;
        <a
          href="mailto:ccoe@resmed.com?subject=I%20have%20a%20question%20about%20CloudCosts"
          target="_blank"
          rel="noreferrer"
        >
          Email
        </a>
      </p>
      <h2>List of Reports</h2>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "1rem",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "center",
                  borderBottom: "1px solid #ddd",
                  padding: "8px",
                }}
              >
                Reporting Timeframe
              </th>
              <th
                style={{
                  textAlign: "center",
                  borderBottom: "1px solid #ddd",
                  padding: "8px",
                }}
              >
                Report Generation Date
              </th>
              <th
                style={{
                  textAlign: "center",
                  borderBottom: "1px solid #ddd",
                  padding: "8px",
                }}
              >
                Download Link
              </th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report) => (
              <tr key={report.path}>
                <td
                  style={{
                    textAlign: "center",
                    padding: "8px",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {report.report_data_date}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    padding: "8px",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {report.generation_date}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    padding: "8px",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <DownloadReport record={report} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ListReport;
